import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {Col, Row} from "react-bootstrap";
import Dropdown from "../../../primer/Dropdown";
import {setNewFixedAssetMovement} from "../../../../_reducers/DataPanel/FixedAssets/fixedAssetsSlice";
import {fetchAdvancedTypes} from "../../../../_apis/api";
import Input from "../../../common/Input";
import DateBox from "../../../primer/DateBox";
import moment from "moment";
import EditableTable from "../../../primer/Editable-Table";
import axios from "axios";
import TextArea from "../../../common/TextArea";
import {isEmpty} from "../../../../_helpers/commonFunctions";
import {setSaveNewFixedAssetMovement} from "../../../../_reducers/activitySlice";
import useInstallationOptions from "../../../../hooks/useInstallationOptions";

const NewFixedAssetMovement = () => {
    const dispatch = useDispatch();
    const newFixedAssetMovement = useSelector((state) => state.FIXED_ASSETS.newFixedAssetMovement);
    const saveNewFixedAssetMovement = useSelector((state) => state.ACTIVITY.saveNewFixedAssetMovement);
    const advancedTypes = useSelector((state) => state.SETTINGS.settings.advancedTypes);
    const company = useSelector((state) => state.COMPANY_DATA.company);

    const installationOptions = useInstallationOptions();
    const [fixedAssetsList, setFixedAssetsList] = useState([]);

    const documentTypesOptions = advancedTypes.length > 0 ?
        advancedTypes.filter((el) => el.section === "Fixed Asset Movements").map((o) => {
            return {
                value: o._id,
                label: o.name,
            }
        })
        : [];

    const preNumberGreekOptions = (advancedTypes.length > 0 && newFixedAssetMovement.installation && newFixedAssetMovement.documentType) ?
        advancedTypes.find((el) => el._id === newFixedAssetMovement.documentType)?.documentNumbering?.map((docNum) => {
            if (docNum.installationMasterId === newFixedAssetMovement.installation) {
                return {
                    value: docNum.preNumber,
                    label: docNum.preNumber === "noprefix" ? "Κενή" : docNum.preNumber,
                    number: docNum.number,
                }
            }
            return null;
        }).filter(Boolean)
        : [];

    const [incrKey, setIncrKey] = useState(0);

    useEffect(() => {
        setIncrKey(incrKey + 1);
    }, [newFixedAssetMovement.fixedAssets, fixedAssetsList])

    const loadFixedAssetsListData = (keyword, setData) => {
        const reqData = {
            company: company.id,
            installation: newFixedAssetMovement.installation,
        }
        if (keyword) reqData.keyword = keyword;
        axios.get(`${process.env.REACT_APP_API_URL2}/fixedassets/list-fixed-assets`, {
            headers: {'Content-Type': 'application/json'},
            params: reqData,
        }).then((res) => {
            if (res.data.status === "200") {
                setData(res.data.data);
            }
        }).catch((err) => {
            setData([]);
            console.log(err);
        })
    }

    const tableColumns  = [
        {
            name: "Αρ.",
            field: "no",
            editable: false,
            width: "5%",
        },
        {
            name: "Κωδικός Συστήματος / Χειροκίνητος Κωδικός",
            field: "mixedCode",
            editable: false,
            width: "30%",
        },
        {
            name: "Όνομα Παγίου",
            field: "name",
            editable: true,
            width: "50%",
            inputType: {
                config: {
                    onChangeSearchCell: (_, keyword, setData) => loadFixedAssetsListData(keyword, setData),
                    excludeColumns: [],
                    columns: [
                        {label: "Όνομα", name: "name"},
                        {label: "Κόστος Κτήσης", name: "acquisitionCost"},
                        {label: "Αποσβεσμένο Ποσό", name: "accumulatedDepreciation"},
                    ],
                    data: fixedAssetsList,
                    deleteEnable: false,
                    searchTableEnable: false,
                    showTableOptionOnSelect: true,
                    placeholder: "Επιλέξτε πάγιο"
                },
                type: 'advanced-combobox',
            }
        },
        {
            name: "Αποσβεσμένο Ποσό",
            field: 'amount',
            editable: true,
            width: "15%",
            inputType: {
                type: 'accounting',
                config: {
                    suffix: "nosuffix",
                    maxLength: 10,
                    allowNegative: true,
                }
            }
        },
    ];

    useEffect(() => {
        dispatch(fetchAdvancedTypes({company: company.id}));
    }, [])

    useEffect(() => {
        loadFixedAssetsListData(null, setFixedAssetsList);
    }, [newFixedAssetMovement.installation])

    const handleOnChange = (e, type, name) => {
        if (!saveNewFixedAssetMovement) dispatch(setSaveNewFixedAssetMovement(true));

        const prepChange = {};
        if (type === "dd") {
            prepChange[name] = e.value;
        } else if (type === "input") {
            prepChange[name] = e.target.value;
        } else if (type === "datebox") {
            if (moment(e).isValid()) {
                prepChange[name] = moment(e).hour(10);
            } else {
                prepChange[name] = "";
            }
        }

        if (name === "documentType") {
            prepChange["documentTypeName"] = e.label;
            const advDoc = advancedTypes.find((el) => el._id === e.value);
            if (advDoc) {
                const preSelectedDocNumbering = advDoc?.documentNumbering?.find((el) => el.selected === "true");
                if (preSelectedDocNumbering) {
                    prepChange["preNumber"] = preSelectedDocNumbering.preNumber;
                    prepChange["number"] = +(preSelectedDocNumbering?.number || 0) + 1;
                }
            }
        } else if (name === "preNumber") {
            prepChange["number"] = +(preNumberGreekOptions.find((el) => el.value === e.value)?.number || 0) + 1;
        }
        dispatch(setNewFixedAssetMovement({...newFixedAssetMovement, ...prepChange}));
    }

    const getSumOfDataValues = (data, field = 'sum') => {
        let sum = 0;
        if (data && data.length > 0) {
            data.forEach(item => {
                sum += +item[field] || 0;
            })
        }
        return +Number(sum).toFixed(2);
    }

    const tableFunctions = {
        insert: (e, data) => {
            if (e.key === "Enter") return;
            if (!saveNewFixedAssetMovement) dispatch(setSaveNewFixedAssetMovement(true));

            if (data.field === "name") {
                const cloneFixedAssets = structuredClone(newFixedAssetMovement.fixedAssets);
                cloneFixedAssets.push({
                    _id: e.row._id,
                    no: String(cloneFixedAssets.length + 1),
                    name: e.row.name,
                    mixedCode: e.row.systemCode + (e.row.manualCode ? ` / ${e.row.manualCode}` : ""),
                    amount: 0,
                });
                dispatch(setNewFixedAssetMovement({
                    ...newFixedAssetMovement,
                    fixedAssets: cloneFixedAssets,
                    sum: getSumOfDataValues(cloneFixedAssets, "amount"),
                }));
            }
        },
        update: (data, id, rowIndex, e) => {
            if (e.key === "Enter") return;
            if (!saveNewFixedAssetMovement) dispatch(setSaveNewFixedAssetMovement(true));

            const cloneFixedAssets = structuredClone(newFixedAssetMovement.fixedAssets);
            const findMatching = cloneFixedAssets[rowIndex];
            if (e?.row) { // Its advanced combo box
                findMatching._id = e.row._id;
                findMatching.name = e.row.name;
                findMatching.mixedCode = e.row.systemCode + (e.row.manualCode ? ` / ${e.row.manualCode}` : "");
                findMatching.amount = 0;
            } else {
                if (!isEmpty(data.amount)) {
                    findMatching.amount = +Number(data.amount).toFixed(2);
                }
            }
            dispatch(setNewFixedAssetMovement({
                ...newFixedAssetMovement,
                fixedAssets: cloneFixedAssets,
                sum: getSumOfDataValues(cloneFixedAssets, "amount"),
            }));
        },
        selected: () => {},
        delete: (id, rowIndex) => {
            if (!saveNewFixedAssetMovement) dispatch(setSaveNewFixedAssetMovement(true));

            const cloneFixedAssets = structuredClone(newFixedAssetMovement.fixedAssets);
            cloneFixedAssets.splice(rowIndex, 1);
            cloneFixedAssets.forEach((row, idx) => {
                row.no = String(idx + 1);
            })
            dispatch(setNewFixedAssetMovement({
                ...newFixedAssetMovement,
                fixedAssets: cloneFixedAssets,
                sum: getSumOfDataValues(cloneFixedAssets, "amount"),
            }));
        }
    }

    const disabledFields = isEmpty(newFixedAssetMovement.documentType);

    return (
        <React.Fragment>
            <div className="product-form position-relative">
                {disabledFields && <div className="overlay_w">Παρακαλώ επιλέξτε τύπο παραστατικού</div>}
                <Row>
                    <Col md={3} className="showWithOverlay">
                        <Dropdown
                            name={"documentType"}
                            label={"Τύπος Παραστατικού"}
                            key={newFixedAssetMovement.documentType}
                            defaultValue={documentTypesOptions.find((el) => el.value === newFixedAssetMovement.documentType)}
                            required={true}
                            options={documentTypesOptions}
                            onChange={(e) => handleOnChange(e, "dd", "documentType")}
                        />
                    </Col>
                </Row>
                <Row className={"mt-2"}>
                    <Col md={3}>
                        <Dropdown
                            name={"installation"}
                            label={"Εγκατάσταση"}
                            key={newFixedAssetMovement.installation}
                            defaultValue={installationOptions.find((el) => el.value === newFixedAssetMovement.installation)}
                            required={true}
                            options={installationOptions}
                            onChange={(e) => handleOnChange(e, "dd", "installation")}
                        />
                    </Col>
                    <Col md={2}>
                        <DateBox
                            label={"Ημερομηνία"}
                            name="date"
                            required={true}
                            selected={moment(newFixedAssetMovement.date).isValid() ? moment(newFixedAssetMovement.date).toDate() : null}
                            onChange={(e) => handleOnChange(e, "datebox", "date")}
                        />
                    </Col>
                    <Col md={2}>
                        <Dropdown
                            label={"Σειρά"}
                            name="preNumber"
                            key={newFixedAssetMovement.preNumber}
                            defaultValue={preNumberGreekOptions.find((el) => el.value === newFixedAssetMovement.preNumber)}
                            options={preNumberGreekOptions}
                            required={true}
                            onChange={(e) => handleOnChange(e, "dd", "preNumber")}
                        />
                    </Col>
                    <Col md={2}>
                        <Input
                            label={"Αρίθμηση"}
                            charLimit={10}
                            name="number"
                            value={newFixedAssetMovement.number}
                            onChange={(e) => handleOnChange(e)}
                            disabled={true}
                        />
                    </Col>
                </Row>
                <Row className={"mt-2"}>
                    <Col md={12}>
                        <Input
                            name={"reason"}
                            label={"Αιτιολογία"}
                            value={newFixedAssetMovement.reason}
                            onChange={(e) => handleOnChange(e, "input", "reason")}
                        />
                    </Col>
                </Row>
                <Row className={"mt-2"}>
                    <Col md={12}>
                        <div className={"text-muted"}><i>Πίνακας παγίων</i></div>
                        <EditableTable
                            tableName={"New Fixed Asset Movement Assets"}
                            key={"New Fixed Asset Movement Assets" + incrKey}
                            allowActions={true}
                            onUpdate={tableFunctions}
                            allowInsertRow={true}
                            columns={tableColumns}
                            enableNewRowCheckbox={true}
                            data={newFixedAssetMovement.fixedAssets}
                        />
                    </Col>
                </Row>
                <Row className={"mt-2"}>
                    <Col md={12}>
                        <TextArea
                            rows={"4"}
                            label={"Σημειώσεις"}
                            name={"notes"}
                            limit={"1000"}
                            value={newFixedAssetMovement.notes}
                            onChange={(e) => handleOnChange(e, "input", "notes")}
                        />
                    </Col>
                </Row>
            </div>
        </React.Fragment>
    )
}

export default NewFixedAssetMovement;
